import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/WEC-SIN33-JOB1/packages/web/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function HiAppPrepaid(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.21 1c.813 0 1.582.304 2.165.854L20.85 6.09a2.97 2.97 0 01.932 2.146V20c0 1.654-1.452 3-3.237 3H6.237C4.452 23 3 21.654 3 20V4c0-1.654 1.452-3 3.237-3h7.972zm0 2H6.236C5.555 3 5 3.448 5 4v16c0 .552.555 1 1.237 1h12.307c.682 0 1.237-.448 1.237-1V8.236a.951.951 0 00-.308-.694L15 3.308A1.156 1.156 0 0014.21 3zm2.35 11.252a.936.936 0 01.656.264.943.943 0 01.264.656.928.928 0 01-.264.655.914.914 0 01-.656.265.914.914 0 01-.655-.265.928.928 0 01-.265-.655.944.944 0 01.265-.656.928.928 0 01.655-.264zm-8.53-5.78v3.36h.021a.902.902 0 01.169-.28c.081-.093.177-.178.29-.25a1.61 1.61 0 01.401-.18c.153-.046.319-.07.5-.07.38 0 .686.059.92.175.233.117.415.278.545.484.13.207.217.45.264.732.047.279.071.582.071.909v2.68h-1.5v-2.38c0-.14-.005-.284-.016-.435a1.381 1.381 0 00-.09-.415.718.718 0 00-.229-.31c-.104-.08-.252-.12-.446-.12a.933.933 0 00-.469.104.727.727 0 00-.276.28 1.18 1.18 0 00-.125.396c-.019.147-.03.3-.03.46v2.42h-1.5v-7.56h1.5zm5.76 2.7v4.86h-1.5v-4.86h1.5zm3.52-2.22v4.74h-1.5v-4.74h1.5zm-4.27-.18c.24 0 .445.085.615.255.17.17.255.375.255.614a.839.839 0 01-.255.616.838.838 0 01-.615.255.836.836 0 01-.614-.255.839.839 0 01-.255-.616c0-.239.085-.444.255-.614a.836.836 0 01.614-.255z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
var MemoHiAppPrepaid = React.memo(HiAppPrepaid);
export default MemoHiAppPrepaid;